<template lang="pug">
mapa-publico(
  ref="mapa"
  idMapa="mapaPublico",
  height="85vh",
  :featureLayerConfig="featureLayerConfig"
  :buttons="buttonsConfig"
  :processos="processos"
)
</template>

<script>

import MapaPublico from '@/screens/portal/publico/components/mapa/MapaPublico'
import layerStyles from '@/utils/layerStyles'

export default {

  components: {
    MapaPublico
  },

  props: {
    processos: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      featureLayerConfig: {
        url: process.env.URL_MAPSERVER_MUNICIPIOS,
        style: layerStyles.ESTADO,
        popup: (layer) => `${layer.feature.properties.NM_MUNICIP}`
      }
    }
  },

  computed: {
    buttonsConfig () {
      return [
        {
          id: 'centralizar',
          icon: 'fa-crosshairs',
          tooltip: 'Centralizar',
          onClick: this.centerMap
        }
      ]
    }
  },

  methods: {
    centerMap () {
      this.$refs.mapa.recenterView()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/ConsultaMapa.vue